<title>{{ ndcCreditVoucherIssuancePage.htmlTitle }}</title>
<app-banner [banner]="ndcCreditVoucherIssuancePage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div class="container-fluid minHeightIssueVoucher">
  <div id="confpn-voucher" class="conf" *ngIf="issueVoucherSuccess">
    <div id="confDet" class="conf">
      <i class="fa fa-check-circle"></i>
      Thankyou. We have recieved your request and will be in touch shortly.
    </div>
  </div>
  <div id="errorpn-VoucherRedeem" *ngIf="issueVocherFailedMsg">
    <div id="errDet" class="err-VoucherRedeem">
      {{ issueVocherFailedMsg }}
    </div>
  </div>
  <div id="issueVoucher" *ngIf="!issueVoucherSuccess">
    <form [formGroup]="issueCreditVoucherForm" (Submit)="sendCreditVoucherIssue(issueCreditVoucherForm)">
      <div id="redemption" class="container brddott mb-50 mt-30 commonFormsCss">
        <div id="preq">
          <div class="row">
            <div id="frm" class="">
              <input type="hidden" id="clTime" name="clTime" value="" />
              <div class="col-sm-12 col-md-7 float-left">
                <h3>{{ CreditVoucherIssueLabels.mainHeading }}</h3>

                <br />
                <h4>{{ CreditVoucherIssueLabels.yourDetailsHeading }}</h4>
                <div class="row ms-3">
                  <div class="col-sm-8">
                    <span class="sml">{{ CreditVoucherIssueLabels.contactName }}<span class="red">*</span></span>
                    <input
                      type="text"
                      formControlName="contactName"
                      placeholder="Contact Name"
                      maxlength="30"
                      class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f['contactName'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactName'].errors">Contact name must be at least 2 characters long & no longer than 30 characters</div>
                  </div>
                </div>
                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">{{ CreditVoucherIssueLabels.contactEmail }}<span class="red">*</span></span
                    ><br />
                    <input type="text" formControlName="contactEmail" placeholder="eMail" maxlength="30" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['contactEmail'].errors }" />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactEmail'].errors">Please enter a valid email address</div>
                  </div>
                </div>
                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">{{ CreditVoucherIssueLabels.contactPhone }}<span class="red">*</span></span
                    ><br />

                    <ngx-intl-tel-input
                      [cssClass]="'custom form-control'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.UnitedKingdom"
                      [maxLength]="15"
                      [phoneValidation]="true"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National"
                      name="phone"
                      formControlName="phone"
                    ></ngx-intl-tel-input>

                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['phone'].errors">Invalid phone number</div>
                  </div>
                </div>

                <br />
                <h4>{{ CreditVoucherIssueLabels.agencyDeatailsHeading }}</h4>
                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">{{ CreditVoucherIssueLabels.agencyName }}<span class="red">*</span></span
                    ><br />
                    <input type="text" formControlName="agencyName" maxlength="100" placeholder="Agency Name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['agencyName'].errors }" />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['agencyName'].errors">Agency must be at least 1 character long & no longer than 100 characters</div>
                  </div>
                </div>

                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">{{ CreditVoucherIssueLabels.iata }} <span class="red">*</span></span
                    ><br />
                    <input
                      type="text"
                      formControlName="IATAnumber"
                      maxlength="10"
                      (keypress)="keyPressNumbers($event)"
                      placeholder="IATA Number"
                      class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f['IATAnumber'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['IATAnumber'].errors">IATA number must between 7 and 10 characters long</div>
                  </div>
                </div>

                <br />
                <h4>{{ CreditVoucherIssueLabels.bookingDetailsHeading }}</h4>

                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">Airline PNR <span class="red">*</span></span
                    ><br />
                    <input
                      type="text"
                      formControlName="airlinePNR"
                      maxlength="6"
                      placeholder="PNR"
                      (keypress)="keyPressSpace($event)"
                      class="form-control"
                      [class]="{ 'is-invalid': submitted && f['airlinePNR'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['airlinePNR'].errors">PNR must be 6 Characters long</div>
                  </div>
                </div>
                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">Lead Passenger LastName <span class="red">*</span></span
                    ><br />

                    <input
                      type="text"
                      formControlName="leadPassengerLastName"
                      placeholder="Last Name"
                      maxlength="30"
                      class="form-control"
                      [class]="{ 'is-invalid': submitted && f['leadPassengerLastName'].errors }"
                    />
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['leadPassengerLastName'].errors">
                      Lead Passenger LastName must be at least 2 characters long & no longer than 30 characters
                    </div>
                  </div>
                </div>

                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <span class="sml">Original Booking Date <span class="red">*</span></span
                    ><br />
                    <input
                      id="bkdate"
                      class="form-control"
                      name="bkdate"
                      type="date"
                      (change)="clearValidationMessage()"
                      formControlName="originalBookingDate"
                      placeholder="dd-mm-yyyy"
                      [max]="getMaxOriginalBookingDate()"
                    />

                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['originalBookingDate'].errors && f['originalBookingDate'].errors['required']">Invalid Date</div>
                  </div>
                </div>

                <div class="row ms-3">
                  <div class="col-sm-8 mt-2">
                    <div>
                      <span class="sml">Outbound Travel Date <span class="red">*</span></span
                      ><br />
                      <input
                        id="tvldate"
                        name="tvldate"
                        type="date"
                        formControlName="outboundTravelDate"
                        (change)="clearValidationMessage()"
                        class="form-control"
                        placeholder="dd-mm-yyyy"
                        [max]="getMaxOutboundTravelDate()"
                      />
                    </div>
                    <div class="field-validation-valid text-danger" *ngIf="submitted && f['outboundTravelDate'].errors && f['outboundTravelDate'].errors['required']">Invalid Date</div>
                    <div class="field-validation-valid text-danger" *ngIf="invalidOutboundDate">Outbound travel date must be after the original booking date</div>
                    <div id="dt-err2" class="hide"></div>
                  </div>
                </div>

                <div class="row mt-4 pt-20 ms-3 tncForVoucher">
                  <div class="col-sm-10">
                    <label id="lbchk1" [ngClass]="{ 'is-invalid': !IsacceptConditions && submitted }">
                      <input id="chk1" name="chk1" type="checkbox" (change)="clearCheckboxValidationMsg()" class="chktxt" formControlName="termsAndConditionsAgree" />
                      I confirm that all we have read and agree with the terms and conditions. <span class="red">*</span>
                    </label>
                  </div>
                </div>

                <div class="row mt-30 pt-30 mb-5">
                  <div class="col-sm-2"></div>
                  <div class="col-sm-6"></div>
                  <div class="col-sm-2">
                    <button (click)="sendCreditVoucherIssue(issueCreditVoucherForm)" type="button" class="btn btn-lg btnblu"><i class="fa fa-edit"></i> Submit</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-5 float-right bggry pt-3">
                <app-section [sections]="ndcCreditVoucherIssuancePage.sections"></app-section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
